// extracted by mini-css-extract-plugin
export var Section = "Competencies-module--Section--E3767";
export var LangHY = "Competencies-module--LangHY--5XC05";
export var ItemText = "Competencies-module--ItemText--I6zoQ";
export var Text = "Competencies-module--Text--ngiOp";
export var HeroWrap = "Competencies-module--HeroWrap--tChBN";
export var HeroImage = "Competencies-module--HeroImage--giVLB";
export var Content = "Competencies-module--Content--aXol7";
export var SectionTitle = "Competencies-module--SectionTitle--UCe6X";
export var Items = "Competencies-module--Items--MLmvY";
export var Item = "Competencies-module--Item--L8-Qt";
export var Card = "Competencies-module--Card--sMMDP";
export var ItemTitle = "Competencies-module--ItemTitle--0avof";
export var ItemImage = "Competencies-module--ItemImage--FyOQu";
export var arrowLeft = "Competencies-module--arrowLeft--b1qXT";
export var arrowRight = "Competencies-module--arrowRight--gbQnt";